exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#agenda-configure-timeslot .product-category-color{width:30px;height:30px;flex:0 0 30px;display:block;border-radius:5px}", ""]);

// exports
